import Vue from 'vue';
import VueRouter from 'vue-router';
import tenDLCRoutes from './tenDLC';

Vue.use(VueRouter);

export const routerParams = {
    mode: 'history',
    base: '',
    routes: [
        ...tenDLCRoutes,
    ],
};

export default new VueRouter(routerParams);